/* Uses the real header and reassurance height; long content is always allowed to grow. */
if (!customElements.get('nn-play-hero')) {
  customElements.define('nn-play-hero', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.observer = new ResizeObserver(this.schedule);
      const header = document.querySelectorAll('.shopify-section-group-header-group');
      header.forEach(element => this.observer.observe(element));
      const strip = this.querySelector('.nn-formula-strip');
      if (strip) this.observer.observe(strip);
      window.addEventListener('resize', this.schedule, { passive: true });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true });
      document.addEventListener('shopify:section:reorder', this.schedule);
      this.schedule();
    }
    measure() {
      const wrapper = this.closest('.shopify-section');
      const preceding = wrapper ? [...wrapper.parentElement.children].slice(0, [...wrapper.parentElement.children].indexOf(wrapper)) : [];
      const isFirst = !preceding.some(element => element.getBoundingClientRect().height > 0);
      this.toggleAttribute('data-first-section', isFirst);
      const headerHeight = [...document.querySelectorAll('.shopify-section-group-header-group')].reduce((total, el) => total + el.getBoundingClientRect().height, 0);
      const stripHeight = this.querySelector('.nn-formula-strip')?.getBoundingClientRect().height || 0;
      this.style.setProperty('--nn-header-height', `${Math.ceil(headerHeight)}px`);
      this.style.setProperty('--nn-strip-height', `${Math.ceil(stripHeight)}px`);
      this.style.setProperty('--nn-screen-height', `${Math.floor(window.visualViewport?.height || window.innerHeight)}px`);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      window.removeEventListener('resize', this.schedule);
      window.visualViewport?.removeEventListener('resize', this.schedule);
      document.removeEventListener('shopify:section:reorder', this.schedule);
    }
  });
}
